import { NavLink } from 'react-router';
import { FC } from 'react';
import { useDrawer } from 'src/hooks/useDrawer';
import { useRoute } from 'src/router/hooks/useRoute';
import { useTranslation } from 'react-i18next';
import { GameCategoriesParams } from 'src/constants/gameCategories';

interface CategoryItemProps {
  option: GameCategoriesParams;
}

export const CategoryItem: FC<CategoryItemProps> = ({ option }) => {
  const { t } = useTranslation();
  const { closeDrawer } = useDrawer();
  const { ROUTE } = useRoute();

  return (
    <NavLink
      to={ROUTE.CUSTOM.get(option.path)}
      onClick={closeDrawer}
      className="w-full h-[50px] rounded-[10px] bg-sgc_category_item_bg hover:bg-sgc_category_item_bg_hovered transition-colors duration-200 cursor-pointer flex justify-start items-center px-2 gap-2 ">
      {option.image}
      <p className="text-sgc_category_item_color text-sm font-medium first-letter:uppercase">
        {t(option.title)}
      </p>
    </NavLink>
  );
};
